module.exports = __webpack_public_path__ + "media/crystal_rift.5cd2a997.webm";